import { useQuery } from '@tanstack/react-query';

import venuePosIntegrationStatus from '../venuePosIntegrationStatus';

const useVenuePosIntegrationStatus = (venueId: string | null) => {
  return useQuery(
    [`/v1/merchant-admin/venues/${venueId}/pos-config`],
    () => (venueId ? venuePosIntegrationStatus(venueId) : null),
    {
      refetchOnWindowFocus: false, // Reduce unnecessary server load
      enabled: !!venueId,
    },
  );
};

export default useVenuePosIntegrationStatus;
